<template>
  <div id="wrapper">
    <div class="div-block-27 w-clearfix">
      <img :src="require('../assets/images/m55.png')" alt="" class="image-13" />
    </div>
    <div class="hero-section cultural-ambassador">
      <div class="_1140-wrap vcenter">
        <h1 class="heading-4 m55">MADRIGAL</h1>
        <div class="div-block-28"></div>
        <p class="paragraph-7" v-html="$t('culturalAmbassador.p1')" />
      </div>
    </div>
    <div>
      <div class="w-layout-grid grid-8">
        <div id="w-node-fcce565c159a-29e09fcb" class="div-block-32 w-clearfix">
          <p class="paragraph-8" v-html="$t('culturalAmbassador.p2')" />
          <p class="paragraph-9" v-html="$t('culturalAmbassador.p3')" />
        </div>
        <div id="w-node-0f787b03cb37-29e09fcb" class="div-block-39">
          <p class="paragraph-10" v-html="$t('culturalAmbassador.p4')" />
        </div>
        <div id="w-node-b1355d7e0ebf-29e09fcb" class="div-block-33"></div>
        <div id="w-node-3c827f6fb760-29e09fcb" class="div-block-42">
          <p class="paragraph-10 whitetext" v-html="$t('culturalAmbassador.p5')" />
        </div>
        <div id="w-node-384d0ffaf580-29e09fcb" class="div-block-37"></div>
        <p
          id="w-node-a8951ca48630-29e09fcb"
          class="paragraph-10 topmargin"
          v-html="$t('culturalAmbassador.p6')"
        />
        <div id="w-node-a740d83b6280-29e09fcb" class="div-block-43"></div>
        <p
          id="w-node-ad4a132f4b59-29e09fcb"
          class="paragraph-10 topmargin"
          v-html="$t('culturalAmbassador.p7')"
        />
        <div id="w-node-dbe51d62e19a-29e09fcb" class="div-block-37">
          <h1 class="heading-5" v-html="$t('culturalAmbassador.p8')" />
          <p class="paragraph-102" v-html="$t('culturalAmbassador.p9')" />
        </div>
        <p
          id="w-node-6c7322ddf105-29e09fcb"
          class="paragraph-10 margin1"
          v-html="$t('culturalAmbassador.p10')"
        />
        <p
          id="w-node-a671357b003d-29e09fcb"
          class="paragraph-10 large"
          v-html="$t('culturalAmbassador.p11')"
        />
        <div id="w-node-eea621079999-29e09fcb" class="div-block-44"></div>
        <div id="w-node-4002b6d03ab8-29e09fcb" class="div-block-38-copy"></div>
        <p
          id="w-node-c7345fd23964-29e09fcb"
          class="paragraph-10 margin1"
          v-html="$t('culturalAmbassador.p12')"
        />
        <p
          id="w-node-2ed156551a66-29e09fcb"
          class="paragraph-10 margin1"
          v-html="$t('culturalAmbassador.p13')"
        />
        <div id="w-node-dba26c1a56d5-29e09fcb" class="div-block-45">
          <h1 class="heading-5 v2" v-html="$t('culturalAmbassador.p14')" />
        </div>
        <p
          id="w-node-be981850dcaa-29e09fcb"
          class="paragraph-10 margin1"
          v-html="$t('culturalAmbassador.p15')"
        />
        <div id="w-node-aedaa83e67a5-29e09fcb" class="div-block-38"></div>
        <div
          id="w-node-d521a136db20-29e09fcb"
          class="div-block-52"
          :style="{
            backgroundImage:
              'url(' + require('../assets/images/note4.svg') + ')'
          }"
        ></div>
        <div id="w-node-de4322038c60-29e09fcb" class="div-block-48"></div>
        <div id="w-node-c6d3bd200953-29e09fcb" class="div-block-46"></div>
        <div id="w-node-1faf8b2d3b20-29e09fcb" class="div-block-47">
          <h1 class="heading-5 v2 n" v-html="$t('culturalAmbassador.p16')" />
          <p class="paragraph-102 v2" v-html="$t('culturalAmbassador.p17')" />
        </div>
        <div id="w-node-13e8ff9354d5-29e09fcb" class="div-block-39">
          <p class="paragraph-10" v-html="$t('culturalAmbassador.p18')" />
        </div>
        <img
          :src="require('@/assets/images/note1.svg')"
          width="107"
          id="w-node-7721f3dfce0e-29e09fcb"
          alt=""
          class="image-14"
        />
        <div id="w-node-8fd662fac626-29e09fcb" class="left-right-border"></div>
        <div id="w-node-26f5691012c7-29e09fcb" class="left-right-border"></div>
        <div
          id="w-node-285045475df7-29e09fcb"
          class="left-right-border only-right"
        ></div>
        <div
          id="w-node-15b55979d6e7-29e09fcb"
          class="div-block-49"
          :style="{
            backgroundImage:
              'url(' + require('../assets/images/note7.svg') + ')'
          }"
        ></div>
        <div
          id="w-node-5798f3006894-29e09fcb"
          class="div-block-50"
          :style="{
            backgroundImage:
              'url(' + require('../assets/images/note3.svg') + ')'
          }"
        ></div>
        <div id="w-node-daf0ae5aa35d-29e09fcb" class="div-block-51"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CulturalAmbassador"
};
</script>

<style scoped>
.grid-8 {
  position: relative;
  z-index: 1;
  margin-top: 316px;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  -ms-grid-columns: auto 14vw 14vw 14vw 14vw auto;
  grid-template-columns: auto 14vw 14vw 14vw 14vw auto;
  -ms-grid-rows: auto auto auto auto auto auto auto auto auto auto auto auto
    auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto
    auto auto auto auto;
  grid-template-rows: auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto;
}

.hero-section {
  position: relative;
  display: block;
  height: 100vh;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  background-color: #2f82bb;
  background-position: 50% 50%;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: scroll;
}

.hero-section.cultural-ambassador {
  height: 85vh;
  background-color: #25313a;
  /*background-image: none;*/
}

.div-block-27 {
  position: absolute;
  top: 1px;
  right: 0px;
  bottom: 1px;
  height: 94vh;
}

._1140-wrap {
  position: relative;
  display: block;
  max-width: 1140px;
  margin-right: auto;
  margin-left: auto;
  padding-top: 0px;
  padding-bottom: 0px;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #fff;
}

._1140-wrap.vcenter {
  position: absolute;
  left: 0px;
  top: 50%;
  right: 0px;
  -webkit-transform: translate(0px, -50%);
  -ms-transform: translate(0px, -50%);
  transform: translate(0px, -50%);
  z-index: 2;
}

._1140-wrap.hcenter {
  padding-top: 20px;
  text-align: center;
}

.heading-4 {
  font-family: Roboto, sans-serif;
  font-size: 5.3em;
  line-height: 1.2em;
  text-transform: uppercase;
}

.heading-4.m55 {
  margin-top: 45px;
  margin-bottom: 0px;
  font-size: 7.8em;
}

.image-13 {
  position: relative;
  display: inline-block;
  overflow: hidden;
  height: 100%;
  float: right;
  z-index: 1;
}

.div-block-28 {
  width: 16%;
  height: 10px;
  background-color: #fff;
}

.paragraph-7 {
  width: 30%;
  margin-top: 58px;
  font-family: Roboto, sans-serif;
  color: #a8c285;
  font-size: 2em;
  line-height: 38px;
  font-weight: 300;
}

#w-node-fcce565c159a-29e09fcb {
  -ms-grid-column: 2;
  grid-column-start: 2;
  -ms-grid-column-span: 5;
  grid-column-end: 7;
  -ms-grid-row: 1;
  grid-row-start: 1;
  -ms-grid-row-span: 1;
  grid-row-end: 2;
}

#w-node-0f787b03cb37-29e09fcb {
  -ms-grid-column: 4;
  grid-column-start: 4;
  -ms-grid-column-span: 2;
  grid-column-end: 6;
  -ms-grid-row: 2;
  grid-row-start: 2;
  -ms-grid-row-span: 2;
  grid-row-end: 4;
}

#w-node-b1355d7e0ebf-29e09fcb {
  -ms-grid-column: 3;
  grid-column-start: 3;
  -ms-grid-column-span: 4;
  grid-column-end: 7;
  -ms-grid-row: 2;
  grid-row-start: 2;
  -ms-grid-row-span: 2;
  grid-row-end: 4;
}

#w-node-3c827f6fb760-29e09fcb {
  -ms-grid-column: 2;
  grid-column-start: 2;
  -ms-grid-column-span: 3;
  grid-column-end: 5;
  -ms-grid-row: 5;
  grid-row-start: 5;
  -ms-grid-row-span: 3;
  grid-row-end: 8;
}

#w-node-384d0ffaf580-29e09fcb {
  -ms-grid-column: 1;
  grid-column-start: 1;
  -ms-grid-column-span: 4;
  grid-column-end: 5;
  -ms-grid-row: 5;
  grid-row-start: 5;
  -ms-grid-row-span: 3;
  grid-row-end: 8;
}

#w-node-a8951ca48630-29e09fcb {
  -ms-grid-column: 4;
  grid-column-start: 4;
  -ms-grid-column-span: 2;
  grid-column-end: 6;
  -ms-grid-row: 8;
  grid-row-start: 8;
  -ms-grid-row-span: 2;
  grid-row-end: 10;
}

#w-node-a740d83b6280-29e09fcb {
  -ms-grid-column: 1;
  grid-column-start: 1;
  -ms-grid-column-span: 3;
  grid-column-end: 4;
  -ms-grid-row: 8;
  grid-row-start: 8;
  -ms-grid-row-span: 4;
  grid-row-end: 12;
}

#w-node-ad4a132f4b59-29e09fcb {
  -ms-grid-column: 3;
  grid-column-start: 3;
  -ms-grid-column-span: 2;
  grid-column-end: 5;
  -ms-grid-row: 11;
  grid-row-start: 11;
  -ms-grid-row-span: 2;
  grid-row-end: 13;
}

#w-node-dbe51d62e19a-29e09fcb {
  -ms-grid-column: 2;
  grid-column-start: 2;
  -ms-grid-column-span: 4;
  grid-column-end: 6;
  -ms-grid-row: 13;
  grid-row-start: 13;
  -ms-grid-row-span: 1;
  grid-row-end: 14;
}

#w-node-6c7322ddf105-29e09fcb {
  -ms-grid-column: 4;
  grid-column-start: 4;
  -ms-grid-column-span: 2;
  grid-column-end: 6;
  -ms-grid-row: 14;
  grid-row-start: 14;
  -ms-grid-row-span: 4;
  grid-row-end: 18;
}

#w-node-a671357b003d-29e09fcb {
  -ms-grid-column: 2;
  grid-column-start: 2;
  -ms-grid-column-span: 3;
  grid-column-end: 5;
  -ms-grid-row: 18;
  grid-row-start: 18;
  -ms-grid-row-span: 1;
  grid-row-end: 19;
}

#w-node-eea621079999-29e09fcb {
  -ms-grid-column: 3;
  grid-column-start: 3;
  -ms-grid-column-span: 4;
  grid-column-end: 7;
  -ms-grid-row: 16;
  grid-row-start: 16;
  -ms-grid-row-span: 4;
  grid-row-end: 20;
}

#w-node-4002b6d03ab8-29e09fcb {
  -ms-grid-column: 1;
  grid-column-start: 1;
  -ms-grid-column-span: 3;
  grid-column-end: 4;
  -ms-grid-row: 21;
  grid-row-start: 21;
  -ms-grid-row-span: 2;
  grid-row-end: 23;
}

#w-node-c7345fd23964-29e09fcb {
  -ms-grid-column: 4;
  grid-column-start: 4;
  -ms-grid-column-span: 2;
  grid-column-end: 6;
  -ms-grid-row: 23;
  grid-row-start: 23;
  -ms-grid-row-span: 2;
  grid-row-end: 25;
}

#w-node-2ed156551a66-29e09fcb {
  -ms-grid-column: 2;
  grid-column-start: 2;
  -ms-grid-column-span: 2;
  grid-column-end: 4;
  -ms-grid-row: 25;
  grid-row-start: 25;
  -ms-grid-row-span: 2;
  grid-row-end: 27;
}

#w-node-dba26c1a56d5-29e09fcb {
  -ms-grid-column: 2;
  grid-column-start: 2;
  -ms-grid-column-span: 2;
  grid-column-end: 4;
  -ms-grid-row: 21;
  grid-row-start: 21;
  -ms-grid-row-span: 2;
  grid-row-end: 23;
}

#w-node-be981850dcaa-29e09fcb {
  -ms-grid-column: 4;
  grid-column-start: 4;
  -ms-grid-column-span: 2;
  grid-column-end: 6;
  -ms-grid-row: 19;
  grid-row-start: 19;
  -ms-grid-row-span: 2;
  grid-row-end: 21;
}

#w-node-aedaa83e67a5-29e09fcb {
  -ms-grid-column: 2;
  grid-column-start: 2;
  -ms-grid-column-span: 1;
  grid-column-end: 3;
  -ms-grid-row: 14;
  grid-row-start: 14;
  -ms-grid-row-span: 1;
  grid-row-end: 15;
}

#w-node-d521a136db20-29e09fcb {
  -ms-grid-column: 2;
  grid-column-start: 2;
  -ms-grid-column-span: 1;
  grid-column-end: 3;
  -ms-grid-row: 14;
  grid-row-start: 14;
  -ms-grid-row-span: 1;
  grid-row-end: 15;
}

#w-node-de4322038c60-29e09fcb {
  -ms-grid-column: 1;
  grid-column-start: 1;
  -ms-grid-column-span: 5;
  grid-column-end: 6;
  -ms-grid-row: 28;
  grid-row-start: 28;
  -ms-grid-row-span: 4;
  grid-row-end: 32;
}

#w-node-c6d3bd200953-29e09fcb {
  -ms-grid-column: 3;
  grid-column-start: 3;
  -ms-grid-column-span: 4;
  grid-column-end: 7;
  -ms-grid-row: 27;
  grid-row-start: 27;
  -ms-grid-row-span: 2;
  grid-row-end: 29;
}

#w-node-1faf8b2d3b20-29e09fcb {
  -ms-grid-column: 3;
  grid-column-start: 3;
  -ms-grid-column-span: 3;
  grid-column-end: 6;
  -ms-grid-row: 27;
  grid-row-start: 27;
  -ms-grid-row-span: 2;
  grid-row-end: 29;
}

#w-node-13e8ff9354d5-29e09fcb {
  -ms-grid-column: 3;
  grid-column-start: 3;
  -ms-grid-column-span: 2;
  grid-column-end: 5;
  -ms-grid-row: 29;
  grid-row-start: 29;
  -ms-grid-row-span: 2;
  grid-row-end: 31;
}

#w-node-7721f3dfce0e-29e09fcb {
  -ms-grid-column: 2;
  grid-column-start: 2;
  -ms-grid-column-span: 1;
  grid-column-end: 3;
  -ms-grid-row: 2;
  grid-row-start: 2;
  -ms-grid-row-span: 1;
  grid-row-end: 3;
}

#w-node-8fd662fac626-29e09fcb {
  -ms-grid-column: 2;
  grid-column-start: 2;
  -ms-grid-column-span: 1;
  grid-column-end: 3;
  -ms-grid-row: 2;
  grid-row-start: 2;
  -ms-grid-row-span: 30;
  grid-row-end: 32;
}

#w-node-26f5691012c7-29e09fcb {
  -ms-grid-column: 4;
  grid-column-start: 4;
  -ms-grid-column-span: 1;
  grid-column-end: 5;
  -ms-grid-row: 1;
  grid-row-start: 1;
  -ms-grid-row-span: 30;
  grid-row-end: 31;
}

#w-node-285045475df7-29e09fcb {
  -ms-grid-column: 5;
  grid-column-start: 5;
  -ms-grid-column-span: 1;
  grid-column-end: 6;
  -ms-grid-row: 5;
  grid-row-start: 5;
  -ms-grid-row-span: 32;
  grid-row-end: 37;
}

#w-node-15b55979d6e7-29e09fcb {
  -ms-grid-column: 5;
  grid-column-start: 5;
  -ms-grid-column-span: 1;
  grid-column-end: 6;
  -ms-grid-row: 6;
  grid-row-start: 6;
  -ms-grid-row-span: 1;
  grid-row-end: 7;
}

#w-node-5798f3006894-29e09fcb {
  -ms-grid-column: 2;
  grid-column-start: 2;
  -ms-grid-column-span: 2;
  grid-column-end: 4;
  -ms-grid-row: 8;
  grid-row-start: 8;
  -ms-grid-row-span: 1;
  grid-row-end: 9;
}

#w-node-daf0ae5aa35d-29e09fcb {
  -ms-grid-column: 4;
  grid-column-start: 4;
  -ms-grid-column-span: 1;
  grid-column-end: 5;
  -ms-grid-row: 8;
  grid-row-start: 8;
  -ms-grid-row-span: 1;
  grid-row-end: 9;
}

.div-block-32 {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding-top: 181px;
  padding-bottom: 164px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
  background-color: #25313a;
}

.div-block-33 {
  position: relative;
  margin-bottom: -196px;
  background-color: #edf9f0;
}

.div-block-35 {
  position: relative;
  z-index: 9;
  display: block;
  background-color: #25313a;
}

.div-block-36 {
  position: relative;
  background-color: #edf9f0;
}

.div-block-37 {
  position: relative;
  display: block;
  padding-top: 98px;
  padding-bottom: 98px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #25313a;
}

.div-block-38 {
  height: 10vh;
  background-color: #25313a;
}

.paragraph-8 {
  position: relative;
  left: 8vw;
  width: 48vw;
  margin-bottom: 45px;
  float: left;
  font-family: "Fira Sans", sans-serif;
  color: #a8c285;
  font-size: 2.6em;
  line-height: 45px;
  font-weight: 200;
}

.paragraph-9 {
  position: relative;
  left: 8vw;
  float: left;
  font-family: "Fira Sans", sans-serif;
  color: #fff;
  font-size: 2em;
  line-height: 25px;
  font-weight: 400;
}

.div-block-39 {
  position: relative;
  z-index: 20;
}

.paragraph-10 {
  margin-top: 114px;
  margin-bottom: 54px;
  padding-right: 75px;
  padding-left: 75px;
  font-family: "Fira Sans", sans-serif;
  font-size: 1.3em;
  line-height: 25px;
  font-weight: 400;
}

.paragraph-10.whitetext {
  margin-top: 194px;
  margin-bottom: 136px;
  padding-right: 50px;
  padding-left: 0px;
  color: #b1b1b1;
  font-size: 1.5em;
  line-height: 33px;
  font-weight: 300;
}

.paragraph-10.margin1 {
  position: relative;
  z-index: 2;
  margin-top: 91px;
  margin-bottom: 109px;
  padding-right: 64px;
  padding-left: 64px;
}

.paragraph-10.large {
  position: relative;
  z-index: 2;
  margin-top: 45px;
  margin-bottom: 45px;
  padding-left: 26px;
  color: #4c6272;
  font-size: 1.7em;
  line-height: 33px;
  font-weight: 400;
}

.paragraph-10.leftright {
  padding-right: 88px;
  padding-left: 88px;
}

.paragraph-10.topmargin {
  margin-top: 137px;
  margin-bottom: 107px;
  padding-right: 135px;
  padding-left: 17px;
}

.text-span-2 {
  font-weight: 700;
}

.paragraph-11 {
  position: relative;
  margin-top: 96px;
  margin-bottom: 96px;
  font-family: "Fira Sans", sans-serif;
  color: #fff;
  font-size: 1.25em;
  line-height: 25px;
  font-style: normal;
  text-align: left;
}

.div-block-40 {
  position: relative;
  left: 61px;
  z-index: 10;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.paragraph-101 {
  margin-top: 96px;
  margin-bottom: 96px;
  font-family: "Fira Sans", sans-serif;
  color: #fff;
  font-size: 1.25em;
  line-height: 25px;
  font-weight: 300;
}

.paragraph-101.whitetext {
  color: #fff;
  line-height: 26px;
}

.div-block-41 {
  background-color: #25313a;
}

.div-block-42 {
  position: relative;
  z-index: 5;
  display: block;
  padding-right: 175px;
  padding-left: 60px;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.div-block-43 {
  background-color: #edf9f0;
}

.heading-5 {
  display: block;
  width: 50%;
  margin-right: auto;
  margin-bottom: 38px;
  margin-left: auto;
  font-family: "Fira Sans", sans-serif;
  color: #fff;
  font-size: 2.4em;
  font-weight: 600;
}

.heading-5.v2 {
  margin-left: 0px;
}

.heading-5.v2.n {
  width: auto;
}

.paragraph-102 {
  display: block;
  width: 50%;
  margin-right: auto;
  margin-left: auto;
  font-family: "Fira Sans", sans-serif;
  color: #fff;
  font-size: 1.2em;
  line-height: 23px;
  font-weight: 300;
}

.paragraph-102.v2 {
  width: auto;
}

.div-block-44 {
  position: relative;
  background-color: #edf9f0;
}

.div-block-38-copy {
  position: relative;
  background-color: #25313a;
}

.div-block-45 {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-top: 74px;
  margin-bottom: 74px;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.div-block-46 {
  position: relative;
  background-color: #25313a;
}

.div-block-47 {
  position: relative;
  padding: 104px 110px 104px 115px;
}

.div-block-48 {
  position: relative;
  left: -9vw;
  background-color: #edf9f0;
}

.left-right-border {
  border-right: 1px solid hsla(0, 0%, 53%, 0.15);
  border-left: 1px solid hsla(0, 0%, 53%, 0.15);
}

.left-right-border.only-right {
  border-left-style: none;
}

.image-14 {
  position: relative;
  left: -3vw;
  top: 28vh;
  right: -3vw;
  height: 10vh;
}

.div-block-49 {
  position: relative;
  left: 7vw;
  top: 4vh;
  height: 15vh;
  background-position: 50% 50%;
  background-size: contain;
  background-repeat: no-repeat;
}

.div-block-50 {
  position: relative;
  left: -3vh;
  top: -7vh;
  height: 21vh;
  background-position: 50% 50%;
  background-size: contain;
  background-repeat: no-repeat;
}

.div-block-51 {
  position: relative;
  left: -75px;
  width: 45%;
  height: 3%;
  margin-top: 112px;
  background-color: #b8e0c2;
}

.div-block-52 {
  position: relative;
  left: -4vw;
  top: 3vh;
  height: 17vh;
  background-size: contain;
  background-repeat: no-repeat;
  opacity: 0.48;
}
</style>
